module.exports = __webpack_public_path__ + "static/media/Slide.6789cda6.jpg";